import React from 'react';
import { Loader2 } from 'lucide-react';

const VARIANTS = {
  primary:
    'bg-rose-600 hover:bg-rose-500 text-white shadow-sm shadow-rose-950/40 focus-visible:ring-rose-500',
  secondary:
    'bg-zinc-800 hover:bg-zinc-700 text-zinc-100 border border-zinc-700 focus-visible:ring-zinc-500',
  ghost:
    'bg-transparent hover:bg-white/5 text-zinc-300 hover:text-white focus-visible:ring-zinc-500',
  premium:
    'bg-amber-400 hover:bg-amber-300 text-zinc-900 shadow-sm shadow-amber-900/30 focus-visible:ring-amber-400',
  danger:
    'bg-transparent hover:bg-red-500/10 text-red-400 hover:text-red-300 focus-visible:ring-red-500',
};

const SIZES = {
  sm: 'px-3 py-1.5 text-xs',
  md: 'px-4 py-2.5 text-sm',
  lg: 'px-6 py-3 text-base',
};

// Botão padrão do app: variantes consistentes, sem exagero de gradientes/emojis.
const Button = ({
  as: Component = 'button',
  variant = 'primary',
  size = 'md',
  icon: Icon,
  loading = false,
  fullWidth = false,
  className = '',
  children,
  disabled,
  ...props
}) => {
  return (
    <Component
      className={`inline-flex items-center justify-center gap-2 rounded-lg font-medium
        transition-colors duration-150 focus-visible:outline-none focus-visible:ring-2
        focus-visible:ring-offset-2 focus-visible:ring-offset-zinc-900 disabled:opacity-50
        disabled:pointer-events-none
        ${VARIANTS[variant]} ${SIZES[size]} ${fullWidth ? 'w-full' : ''} ${className}`}
      disabled={disabled || loading}
      {...props}
    >
      {loading ? (
        <Loader2 className="h-4 w-4 animate-spin" />
      ) : (
        Icon && <Icon className="h-4 w-4" strokeWidth={2} />
      )}
      {children}
    </Component>
  );
};

export default Button;
